

function CustomEncrypt(text) {
    let key = "6Le0DgMTAs"; 
    const CryptoJS = require('crypto-js');
    var encryptedString = CryptoJS.AES.encrypt(text, key).toString();

    return encryptedString;
}

function CustomDescrypt(text) {
    let key = "6Le0DgMTAs"; 
    const CryptoJS = require('crypto-js');

    let bytes = CryptoJS.AES.decrypt(text, key);
    let data = bytes.toString(CryptoJS.enc.Utf8);

    return data;
}

export { CustomEncrypt, CustomDescrypt }